export default {
  methods: {

    draw_Table() {
      
      let tbl = this.table
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${tbl.y})`)

      let y_ =  0
      let mY  = 0
      let tCount = 0
      let dataCount = this.columns.length-1

      this.rawData.forEach((d,i)=> {

        mY  = y_ - tbl.lineHeight/2
        this.columns.forEach(col=> {

          if(col.code == 'PROG') {

            let proLen = (col.width / 100) * d[col.code]

            table
            .append('rect')
            .attr('x', col.sx).attr('y', mY - tbl.tSize/2)
            .attr('width', col.width).attr('height', tbl.tSize).attr('fill', '#bcbcbc').attr('opacity', .15)

            table
            .append('rect')
            .attr('transform', `translate(${col.sx}, ${mY - tbl.tSize/2})`)
            .attr('width', proLen).attr('height', tbl.tSize)
            .attr('stroke-width', 0.3)
            .attr('stroke', tbl.bStroke).attr('stroke-opacity', .5)
            .attr('fill', tbl.bColor)
            .attr('fill-opacity', tbl.opacity)

            table
            .append('text')
            .attr('id', `${col.code}_${i}`)
            .attr('x', d[col.code] > 75 ? col.sx + proLen - 2 : col.sx + proLen + 2)
            .attr('y', mY + tbl.tSize*0.36)
            .attr('text-anchor', d[col.code] > 75 ? 'end' : 'start')
            .attr('font-size', tbl.tSize).attr('fill', col.tColor)
            .text(`${d[col.code]}%`)

          } else {

            table
            .append('text')
            .attr('transform', `translate(${col.x}, ${mY + tbl.tSize*0.36})`)
            .attr('font-size', tbl.tSize)
            .attr('fill', col.tColor)
            .attr('text-anchor', col.align)
            .attr('cursor', col.filter !== '' ? 'pointer' : 'default')
            .text( (i>0 && col.group == 'Y' && d[col.code] == this.rawData[i-1][col.code]) ? '' : d[col.code])
            .call(this.event_Link, d, col, col.tColor)

          }
        
        })
      
        y_ = y_ + tbl.lineHeight
      })
      
      
    },
  }
}